import AvailableEvent from './AvailableEvent'

export default AvailableEvent
